module.exports = __webpack_public_path__ + "static/thinkster-3441cc86f048c32613ba351b98fb35ae.svg";